import React from 'react'
import { useSelector } from 'react-redux'
import { getUnitsCancel, getUnitsIndividual } from '../../../Units/selectors'

export const useCancelTableData = () => {
  const cancelUnits = useSelector(getUnitsCancel)
  const individualUnits = useSelector(getUnitsIndividual)

  return React.useMemo(
    () =>
      cancelUnits.map((cu) => {
        const obj = individualUnits.find(
          (iu) => String(iu.subscriptionId) === String(cu.subscriptionId)
        )
        if (obj) {
          return {
            ...obj,
            ...cu,
          }
        }
        return cu
      }),
    [cancelUnits, individualUnits]
  )
}
